/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Possible outcomes of payee verification:
 * * `MATCH` - The provided “payee” name match exactly with the account holder name.
 * * `CLOSE_MATCH` - The provided “payee” name closely resemble the account holder name.
 * * `NO_MATCH` - The provided “payee” name does not match with the account holder name.
 * * `NOT_POSSIBLE` - VOP is not possible due to technical errors on the VOP service.
 * * `NOT_SUPPORTED` - VOP result is not provided since payee country is not ready for VOP.
 * * `NOT_REQUESTED` (Deprecated, use VERIFICATION_DISABLED instead) - VOP was not requested by the user in bulk transfer (this is indicated, when FE does not provide flag “payeeVerificationRequested“ on bulk header level). Value is relevant only for George Business.
 * * `VERIFICATION_DISABLED` - VOP was not requested by the user in bulk transfer - allowed only if account setting is opt-out (this is provided, when FE does not provide flag “payeeVerificationEnabled“ on bulk header level). Value is relevant only for George Business.
 * * `PARTICIPANT_OUTSIDE_OF_EEA` - Not possible to perform VOP check because receiver is outside of EEA.
 * * `INITIATING_ACCOUNT_THIRD_PARTY` - Not possible to perform VOP check because initiating account is third party (MBS, EBICS).
 * * `PARTICIPANT_OWN_ACCOUNT` - Not possible to perform VOP check because initiating account is own account.
 * * `NO_CANDIDATE` - VOP is not relevant for such receiver. Swiss accounts for example -> Sepa payment outside of EEA.
 * * `UNKNOWN` - Fallback value. Reserved for compatibility reasons.
 *
 */
export enum PayeeVerificationResultEnum {
    MATCH = 'MATCH',
    CLOSE_MATCH = 'CLOSE_MATCH',
    NO_MATCH = 'NO_MATCH',
    NOT_POSSIBLE = 'NOT_POSSIBLE',
    NOT_SUPPORTED = 'NOT_SUPPORTED',
    NOT_REQUESTED = 'NOT_REQUESTED',
    VERIFICATION_DISABLED = 'VERIFICATION_DISABLED',
    PARTICIPANT_OUTSIDE_OF_EEA = 'PARTICIPANT_OUTSIDE_OF_EEA',
    INITIATING_ACCOUNT_THIRD_PARTY = 'INITIATING_ACCOUNT_THIRD_PARTY',
    PARTICIPANT_OWN_ACCOUNT = 'PARTICIPANT_OWN_ACCOUNT',
    NO_CANDIDATE = 'NO_CANDIDATE',
    UNKNOWN = 'UNKNOWN',
}
